import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { CartImpressionTrackingInfo } from "@omni/types/components/tracking/tracking-info/impression/cartImpression.trackingInfo";

import { CartModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { toCartImpressionTrackingInfo } from "@/services/tracking/mappers/cart.mapper";
import { getPageInfo, getUserInfo } from "@/services/tracking/trackers/utils";
import * as TrackingService from "@/services/tracking/tracking.service";
import { TypedAnalyticsEvent } from "@/services/tracking/types/analyticsEvent";

export const track = (trackingInfo: CartImpressionTrackingInfo) => {
    const event: TypedAnalyticsEvent<CartImpressionTrackingInfo> = {
        event: EventType.CartImpression,
        payload: {
            eventData: trackingInfo,
            pageInfo: getPageInfo(),
            userInfo: getUserInfo()
        }
    };

    TrackingService.track(event);
};

export const trackCart = (cart: CartModel) => {
    const trackingInfo = toCartImpressionTrackingInfo(cart);

    track(trackingInfo);
};
